<script setup lang="ts">
  import { MessageSquare } from "lucide-vue-next";
  import { IndexTableEmpty } from "@/components/episto-ui/index-table";
  import { Skeleton } from "@/components/ui/skeleton";
  import { removeHtmlMarkdownAndLineBreak } from "@utils/toolBox.js";
  import { quotesLabel } from "./gridColumns";
  import type { GridCell } from "@/types";

  defineProps<{ cell?: GridCell | null }>();

  defineEmits<{ select: [] }>();
</script>

<template>
  <button
    v-if="cell?.answer"
    type="button"
    class="block w-full cursor-pointer text-left"
    @click.stop="$emit('select')">
    <span class="line-clamp-2 whitespace-normal leading-snug">{{ removeHtmlMarkdownAndLineBreak(cell.answer) }}</span>
    <span
      v-if="cell.status === 'done'"
      class="mt-1 flex items-center gap-1 text-xs text-muted-foreground">
      <MessageSquare class="size-3" />
      {{ quotesLabel(cell.citations.length) }}
    </span>
  </button>
  <span
    v-else-if="cell?.status === 'failed'"
    class="text-xs text-status-error-strong">
    Generation failed
  </span>
  <Skeleton
    v-else-if="cell"
    class="h-3 w-3/4" />
  <IndexTableEmpty v-else />
</template>
